import { Tag } from "antd";
import { categoryMap, jobTypeLabels } from "../utils/jobMapping";
import "./Components.css";

const JobFilters = ({ jobData }) => {
  return (
    <div className="job-filters">
      {/* Ant Design Tags */}
      <Tag
        style={{
          backgroundColor: "#FAFAFA",
          color: "#00000099",
          border: "1px solid #D9D9D980",
        }}
      >
        {jobData?.location}
      </Tag>
      <Tag
        style={{
          backgroundColor: "#FAFAFA",
          color: "#00000099",
          border: "1px solid #D9D9D980",
        }}
      >
          {jobTypeLabels[jobData?.job_type] || jobData?.job_type || "Not specified"}
      </Tag>
      <Tag
        style={{
          backgroundColor: "#FAFAFA",
          color: "#00000099",
          border: "1px solid #D9D9D980",
        }}
      >
          {jobData?.category === '1' && jobData?.custom_category
              ? jobData.custom_category
              : categoryMap[jobData?.category] || "Not specified"
          }
      </Tag>
    </div>
  );
};
export default JobFilters;
